import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { FileUploaderComponent } from '../file-uploader/file-uploader.component';

@Component({
  selector: 'app-create-consolidated-invoice',
  templateUrl: './create-consolidated-invoice.component.html',
  styleUrls: ['./create-consolidated-invoice.component.scss']
})
export class CreateConsolidatedInvoiceComponent implements OnInit {
  @Input() selectedShipmentIds : any;
  plantCode: any;
  carrierInvoiceNumber: any;
  totalAmount = 0;
  odcCharges=0;
  taxDetails = '1';
  uploadType:any;
  tds;
  comments: any = '';
  dialogRef: any;
  enableButton = true;
  constructor(@Inject(MAT_DIALOG_DATA) private parentData: any,private dialog: MatDialogRef<CreateConsolidatedInvoiceComponent>, private http: HttpService, private snackBar: SnackbarService, private popup: MatDialog) { 
    this.date = new Date();
    this.date.setHours(12, 0, 0, 0); // Set the time to 12 PM

  }
  displayedColumns = ['sno',
    'sin',
    'invoice',
    // 'carrierInvoice',
    // 'odNumber',
    'chargeWeight',
    'freightRate',
    'freightAmount',
    // 'rtoWeight',
    // 'weightExtra',
    // 'sapWeight',
    //     'materialRate',
    'rtoAmount',
    // 'shortage',
    'detentionCharges',
    'incentives',
    'remarks',
    'attachments',
    'OdcCharges',
    'epods',
  ];
  displayedColumnsForExtraCharges = [
    'sno',
    'invoice',
    'rtoCharges',
    'mwg',
    'multipleUnloadingPoint',
    'detentionCharges',
    'multipleLoadingPoint',
    'incentives',
    'odcCharges',
    'theoretical_extra_charges',
  ];

  displayedColumnsForDeductions = [
    'sno',
    'invoice',
    'deductions',
  ]
  dataSource = [];
  extraCharges = [];
  invoices = [];
  date  : Date;
  uploadID:any

  ngOnInit() {
    this.invoices = this.parentData.invoices[0].invoices;
    this.plantCode = this.parentData.invoices[0].plant;
    this.carrierInvoiceNumber = this.parentData.invoices[0].invoices[0].commercial_invoices[0].num;
    this.uploadID = this.parentData.invoices[0].invoices[0]._id;
    this.selectedShipmentIds =this.parentData._id;
    this.invoices.forEach((inv, i) => {
      const { commercial_invoices, shipment_no, shipment_id, _id, total_net_weight } = inv;
       const temp = {
        _id,
        sno: i + 1,
        sin: shipment_no,
        shipment_id,
        invoice: commercial_invoices[0].num,
        // carrierInvoice: '',
        odNumber: commercial_invoices[0].others.do_number,
        chargeWeight:( commercial_invoices[0].others.chargeWeight).toFixed(3) || 0,
        freightRate: commercial_invoices[0].others.final_freight_rate || 0,
        freightAmount: (commercial_invoices[0].others.chargeWeight * commercial_invoices[0].others.final_freight_rate),
        vehicle_capacity: commercial_invoices[0].others.vehicle_capacity || 0,
        mwg: commercial_invoices[0].others.MWG && Number((commercial_invoices[0].others.MWG).toFixed(3)) || 0,
        sapWeight: total_net_weight || 0,
        materialRate: commercial_invoices[0].others.material_rate || 0,
        rtoAmount: commercial_invoices[0].others.rtoAmount || 0,
        shortage: commercial_invoices[0].others.shortage || 0,
        odc_charge_uom: commercial_invoices[0].others.odc_charge_uom || 0,
        odcCharges: commercial_invoices[0].others.odcCharges || 0,
        extra_charges: commercial_invoices[0].others.theoretical_extra_charges || 0,
        detentionCharges: commercial_invoices[0].others.detention || 0,
        multipleUnloadingPoint: commercial_invoices[0].others.extraDelivery || 0,
        multipleLoadingPoint: commercial_invoices[0].others.extraPickup || 0,
        incentives: commercial_invoices[0].others.incentive || 0,
        deductions: commercial_invoices[0].others.shortage_amount || 0,
        remarks: commercial_invoices[0].others.additional_charge_remark || '',
        attachments: commercial_invoices[0].others.additional_charge_attachments || [],
        first: commercial_invoices[0].others.first || false,
        odc: commercial_invoices[0].others.odc || false,
        epods: commercial_invoices[0].others.epods || [],
        weight_extra: commercial_invoices[0].others.weight_extra || 0,
        theoreticalWeight:commercial_invoices[0].others.theoreticalWeight || 0,
        final_freight_rate: commercial_invoices[0].others.final_freight_rate || 0,
        sectionalWeight: commercial_invoices[0].others.sectional_weight || 0,
        invoiceWeight: commercial_invoices[0].others.invoiceWeight || 0,
        toolTipText: commercial_invoices[0].others.first ? `Sectional weight: ${commercial_invoices[0].others.sectional_weight || 0} MT, \nInvoice weight: ${commercial_invoices[0].others.invoiceWeight || 0} MT, \nVehicle capacity: ${commercial_invoices[0].others.vehicle_capacity} MT`: '',
      }
      this.dataSource.push(temp);
      
      this.extraCharges.push(temp);
    });
    
    this.calculateTotal();
  }

  updatingMultipleUnloading(item) {  
    this.calculateTotal();
    const payload = {
      unloading : 0,
      invoiceId: item._id,
    }
    this.http.post('v1/updateExtraCharge', payload, 1).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.snackBar.openSnackBar('Updated Successfully', '');
        }
      },
      (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    )
  }
  updatingMultipleloading(item) {
    this.calculateTotal();
    const payload = {
      loading : 0,
      invoiceId: item._id,
    }
    this.http.post('v1/updateExtraCharge', payload, 1).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.snackBar.openSnackBar('Updated Successfully', '');
        }
      },
      (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    )
  }

  createConsolidatedInvoice() {
    this.enableButton = false;
    let allFieldsValid = true;
    this.dataSource.forEach(item => item.rowError = false);

    for (const item of this.dataSource) {
      if (!item.epods || item.epods.length === 0) {
        this.snackBar.openSnackBar(`Please upload ePOD for ${item.invoice} invoice`, '', 'err');
        item.rowError = true;
        allFieldsValid = false;
        break;
      }

      if (item.remarksErrorMessage) {
        this.snackBar.openSnackBar(`Please correct remarks for invoice ${item.invoice}. Invalid characters are present.`, '', 'err');
        item.rowError = true;
        allFieldsValid = false;
        break;
      }

      if (item.incentives > 0) {
        if (!item.remarks || item.remarks.trim() === '') {
          this.snackBar.openSnackBar(`Additional Charges Remark is mandatory for invoice ${item.invoice} when additional charge's are greater than zero.`, '', 'err');
          item.rowError = true;
          allFieldsValid = false;
          break;
        }
        if (!item.attachments || item.attachments.length === 0) { 
          this.snackBar.openSnackBar(`Additional Charges Attachment is mandatory for invoice ${item.invoice} when additional charge's are greater than zero.`, '', 'err');
          item.rowError = true;
          allFieldsValid = false;
          break;
        }
      }
    }

    if (!allFieldsValid) {
      this.enableButton = true; 
      this.dataSource = [...this.dataSource];
      return;
    }

    this.date.setHours(12, 0, 0, 0);
    const payload = {
      plant_code: this.plantCode,
      carrierInvoiceNumber: this.carrierInvoiceNumber,
      invoicedDate: this.date,
      tds: this.tds,
      comment: this.comments,
      ...(this.taxDetails === '1' && { cgst_sgst: true, igst: false }),
      ...(this.taxDetails === '2' && { igst: true, cgst_sgst: false }),
      invoices: this.dataSource.map(i => {
        return {
          _id: i._id,
          shipment_id: i.shipment_id,
          "rto_amount": i.rtoAmount,
          "incentive": i.incentives == null ? 0 : i.incentives,
          "multi_delivery": i.multipleUnloadingPoint,
          "multi_pickup": i.multipleLoadingPoint,
          "discount": 0,
          "odc_charge_uom":i.odc_charge_uom,
          "detention":i.detentionCharges,
          "theoretical_extra_charges":i.extra_charges,
          "theoreticalWeight":i.theoreticalWeight,
          "final_freight_rate":i.final_freight_rate,
          // carrier_invoice_number: i.carrierInvoice,
          commercial_invoices: [{
            num: i.invoice,
            others: {
              additional_charges: i.incentives,
              additional_charges_remark: i.remarks,
            }
          }]
        }
      })
    };
    this.http.post('carrier_invoice/generateCIByInvoice', payload, 1).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.snackBar.openSnackBar('Invoice generated successfully');
          this.enableButton = true;
          this.dialog.close();
        }
      },
      (err: any) => {
        this.enableButton = true;
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    )
  }

  calculateTotal() {
    this.totalAmount = Math.round(this.dataSource.reduce((a, b) => a + b.freightAmount
     + b.rtoAmount
    + b.mwg
    + b.multipleUnloadingPoint
    + b.multipleLoadingPoint
    + b.detentionCharges
    + b.incentives
      + (b.odc_charge_uom * Math.max(b.vehicle_capacity, b.invoiceWeight))
    + ((b.theoreticalWeight < 0 && b.odc_charge_uom > 0) ? (b.theoreticalWeight * (b.odc_charge_uom + b.final_freight_rate)) : (b.extra_charges || 0))
    - b.deductions, 0));
  }


  openFileUploaderInvoice(type) {
    const payload = {
      url: 'carrier_invoice/attachment',
       _id: this.parentData.selectedShipmentId,
       plant_code: this.plantCode,
    };
    this.dialogRef = this.popup.open(FileUploaderComponent, {
      data: {
        payload,
        type
      }
    });
    this.dialogRef.afterClosed().subscribe(
      (data: any) => {
        console.log(data);
      }
    )
  }
  openFileUploader(element) {
    const payload = {
      url: 'v3/shipment/upload_epod/',
      _id: element._id
    };
    this.dialogRef = this.popup.open(FileUploaderComponent, {
      data: payload
    });
    this.dialogRef.afterClosed().subscribe(
      (response: any) => {

        if (response && response.statusCode === 200 && response.data && typeof response.data.filePath === 'string') {
          const newAttachmentUrl = response.data.filePath;
          element.epods = [...(element.epods || []), newAttachmentUrl];
          if (element.epods && element.epods.length > 0) {
            element.rowError = false;
          }
          this.dataSource = [...this.dataSource]; 
          this.snackBar.openSnackBar('Epod attachments uploaded successfully!', '', 'success');
        } else if (response && response.message !== 'closed') {
            this.snackBar.openSnackBar(response.msg || 'Upload failed', '', 'err');
        }
      }
    )
  }

   downloadEpods(epods) {
    
    const urls = epods;
    for (let link of urls) {
      window.open(link, '_blank');
    }
  }

  downloadAdditionalCharge(attachments) {
    if (!attachments || attachments.length === 0) {
      this.snackBar.openSnackBar('No additional charge attachments to download.', '', 'info');
      return;
    }
    for (let attachment of attachments) {
      const url = typeof attachment === 'string' ? attachment : attachment.url;
      if (url) {
        window.open(url, '_blank');
      }
    }
  }

  openAdditionalChargeAttachment(element) {
    if (!element.first || element.incentives === 0) {
      return; 
    }
    const payloadForDialog = {
      type: 'additional_charge',
      url: 'v1/shipment/upload_additional_charges/', 
      path_param_id: element._id, 
      commercial_invoice_num: element.invoice,
    };
    this.dialogRef = this.popup.open(FileUploaderComponent, {
      data: payloadForDialog 
    });
    this.dialogRef.afterClosed().subscribe(
      (response: any) => { 
        if (response && response.statusCode === 200 && response.data && typeof response.data.filePath === 'string') {
          const newAttachmentUrl = response.data.filePath;
          element.attachments = [...(element.attachments || []), newAttachmentUrl];
          if (element.attachments && element.attachments.length > 0) {
            element.rowError = false;
          }
          this.dataSource = [...this.dataSource]; 
          this.snackBar.openSnackBar('Additional charge attachments uploaded successfully!', '', 'success');
        } else if (response && response.message !== 'closed') {
            this.snackBar.openSnackBar(response.msg || 'Upload failed', '', 'err');
        }
      }
    );
  }

  onRemarksChange(element: any, newValue: string): void {
    const disallowedCharsRegex = /[^a-zA-Z0-9\s\-\.]/g;
    let sanitizedValue = newValue;

    if (newValue && disallowedCharsRegex.test(newValue)) {
      element.remarksErrorMessage = 'Please use only letters, numbers, spaces, hyphens (-), and periods (.)';
      sanitizedValue = newValue.replace(disallowedCharsRegex, '');
    } else {
      element.remarksErrorMessage = null; 
    }
    if (element.remarks !== sanitizedValue) {
      element.remarks = sanitizedValue;
    }

    if ( (!element.remarksErrorMessage) &&
      (element.incentives === 0 || (element.remarks && element.remarks.trim() !== '')) &&
      (element.incentives === 0 || (element.attachments && element.attachments.length > 0))
    ) {
      element.rowError = false;
      this.dataSource = [...this.dataSource];
    }
  }

}
